import { API_ENDPOINTS } from './apiEndpoint'
import axiosRequest from './axios'
import { LocalStorageService, HELPER, CONSTANTS } from '../../utils'

const s3_base_path = process.env.REACT_APP_S3_BASE_PATH
const s3_environment = process.env.REACT_APP_ENVIRONMENT
const s3_catalog_folder_path = process.env.REACT_APP_S3_CATALOG_FOLDER_NAME
const s3_stores_list_folder_path = process.env.REACT_APP_S3_STORES_LIST_FOLDER_NAME

const catalogBaseURL = s3_base_path + '/' + s3_environment + '/' + s3_catalog_folder_path + '/'
const storesBaseURL = s3_base_path + '/' + s3_environment + '/' + s3_stores_list_folder_path + '/'

const baseURL = process.env.REACT_APP_API_BASE_URL

export const apiService = {
	storeConfiguration,
	catalogueConfiguration,
	storesListing,
	createOrder,
}

/*
 *STORE CONFIG APIS
 */
async function storeConfiguration(store_name) {
	let configFileName = process.env.REACT_APP_CONFIG_FILE_NAME
	let configURL = catalogBaseURL + store_name + '/' + configFileName + '?v=' + new Date().getTime()
	let response = await axiosRequest('get', `${configURL}`, false)()
	return response
}

/*
 *STORE CONFIG APIS
 */
async function catalogueConfiguration(store_name) {
	let configFileName = process.env.REACT_APP_CATALOG_FILE_NAME
	let locale = LocalStorageService._getFromSessionStorage('locale')
	locale = !HELPER.isEmpty(locale) ? locale : CONSTANTS.IS_ENGLISH
	let configURL =
		catalogBaseURL + store_name + '/' + locale + '-' + configFileName + '?v=' + new Date().getTime()
	let response = await axiosRequest('get', `${configURL}`)()
	return response
}

/*
 *STORE LIST APIS
 */
async function storesListing() {
	let configFileName = process.env.REACT_APP_STORE_LIST_FILE_NAME
	let locale = LocalStorageService._getFromSessionStorage('locale')
	locale = !HELPER.isEmpty(locale) ? locale : CONSTANTS.IS_ENGLISH
	let response = await axiosRequest(
		'get',
		`${storesBaseURL}${locale}-${configFileName}?v=${new Date().getTime()}`
	)()
	return response
}

/*
 *PLACE ORDER APIS
 */
async function createOrder(requestData) {
	let response = await axiosRequest('post', `${baseURL}` + API_ENDPOINTS.CREATE_ORDER)(requestData)
	return response
}
